export default __webpack_public_path__ + "static/media/151-mallet.08ed9974.png";